import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.CUSTOMER_UX_CODE,
  displayName: "Customer Ux Code",
  isCustomerFacing: false,
};

export default entitlement;
